import { useCallback } from 'react';

export function useCtrlClickNavigation() {
  return useCallback((event: React.MouseEvent, pathnameOrHref: string) => {
    const url = pathnameOrHref.startsWith('/')
      ? new URL(pathnameOrHref, window.location.origin).toString()
      : pathnameOrHref;

    if (event.ctrlKey || event.metaKey || event.button === 1) {
      window.open(url, '_blank');
      return true;
    }
    return false;
  }, []);
}
